import React from "react";
import { useAttributeFormBuilder, useLayout } from "../../../../Hooks/Display/useComponentProperties";
import { useTranslation } from "react-i18next";

const SectionActions = ({ sectionId }) => {

    const { t } = useTranslation([
        "display/components/form"
    ]);

    const [{ steps }, dispatch] = useAttributeFormBuilder();
    const layout = useLayout()

    const sectionIndex = layout.findIndex((section) => section.id === sectionId);
    const isMoveUpDisabled = sectionIndex === 0;
    const isMoveDownDisabled = sectionIndex === layout.length - 1;
    const isRemoveDisabled = layout.length === 1;

    const handleMoveSectionUp = (sectionId) => {
        dispatch.moveSectionUp(sectionId);
    }

    const handleMoveSectionDown = (sectionId) => {
        dispatch.moveSectionDown(sectionId);
    }

    const handleRemoveSection = (sectionId) => {
        dispatch.removeSection(sectionId);
    }

    return (
        <div>
            <button
                disabled={isMoveUpDisabled}
                title={t("section.title.move_up", { ns: "display/components/form" })}
                className="btn btn-link"
                onClick={() => handleMoveSectionUp(sectionId)}>
                <i className={`fa-solid fa-up ${isMoveUpDisabled ? "text-muted" : "text-primary"}`}></i>
            </button>
            <button
                disabled={isMoveDownDisabled}
                title={t("section.title.move_down", { ns: "display/components/form" })}
                className="btn btn-link"
                onClick={() => handleMoveSectionDown(sectionId)}>
                <i className={`fa-solid fa-down ${isMoveDownDisabled ? "text-muted" : "text-primary"}`}></i>
            </button>
            <button
                disabled={isRemoveDisabled}
                title={t("section.title.remove_section", { ns: "display/components/form" })}
                className="btn btn-link"
                onClick={() => handleRemoveSection(sectionId)}>
                <i className="fa-regular fa-trash text-danger"></i>
            </button>
        </div>
    );
};

export default SectionActions;